export enum enumVerandaPriceTypes {
    VerandaDeluxeMiniCubeClassic = 1,
    VerandaDeluxeMiniCubeClassicWithHelder = 2,
    VerandaDeluxeMiniCubeClassicWithOpaal = 3,
    VerandaDeluxeMiniCubeClassicWithGetint = 4,
    Zonwering = 5,
    RsScreen = 6,
    Lamellendak = 7
};